export var createBrandsApi = function (baseUrl, http) {
    var brandApiUrl = "".concat(baseUrl, "/brand");
    return {
        getAllBrands: function (enabled) {
            return http.get("".concat(brandApiUrl).concat(enabled ? '?enabled=true' : ''));
        },
        getBrand: function (dto) {
            return http.get("".concat(brandApiUrl, "/").concat(dto.id));
        },
        addBrand: function (dto) {
            return http.post(brandApiUrl, dto);
        },
        updateBrand: function (dto) {
            return http.post("".concat(brandApiUrl, "/").concat(dto.id, "/update"), { name: dto.name, logoUrl: dto.logoUrl });
        },
        enableBrand: function (dto) {
            return http.post("".concat(brandApiUrl, "/").concat(dto.id, "/enable"), {});
        },
        disableBrand: function (dto) {
            return http.post("".concat(brandApiUrl, "/").concat(dto.id, "/disable"), {});
        },
        isSubdomainAvailable: function (name) {
            return http.post("".concat(brandApiUrl, "/nameAvailable"), { name: name });
        }
    };
};
//# sourceMappingURL=index.js.map